import {AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormBuilder} from '@angular/forms';
import {GenericAttachedFile} from '@shared/components/view-files/models/attachments-interface';
import {InnerMessagesService} from '@shared/service/inner-messages.service';
import {DomSanitizer} from '@angular/platform-browser';
import {TranslateContext} from '@shared/pipes/translate.pipe';
import {FileExtensionFromMimeTypeMap, FileMimeTypeModel} from '@shared/models/file-mime-type.model';

@Component({
	selector: 'amd-generic-view-attachment-preview-dialog',
	templateUrl: './generic-view-attachment-preview-dialog.component.html',
	styleUrls: ['./generic-view-attachment-preview-dialog.component.scss']
})
export class GenericViewAttachmentPreviewDialogComponent implements AfterViewInit, AfterViewChecked {

	file: GenericAttachedFile;
	translateContext: typeof TranslateContext = TranslateContext;
	imageToShow: any;

	mimeTypeSupportedForThumbnailList: FileMimeTypeModel[] = [FileMimeTypeModel.TIF, FileMimeTypeModel.TIFF,
		FileMimeTypeModel.GIF, FileMimeTypeModel.JPEG, FileMimeTypeModel.JPG, FileMimeTypeModel.PNG,
		FileMimeTypeModel.PDF];
	labelTitle: string;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public fb: FormBuilder,
		private sanitizer: DomSanitizer,
		public dialogRef: MatDialogRef<GenericViewAttachmentPreviewDialogComponent>,
		public innerMessagesService: InnerMessagesService,
		private cdRef: ChangeDetectorRef) {
		this.file = data.file;
		this.translateContext = data.translateContext;
		this.labelTitle = data.labelTitle || 'Categoria';
	}

	ngOnInit(): void {
	}

	ngAfterViewInit(): void {
		//TODO: check method bypassSecurityTrustUrl!!
		if (this.file.blob !== -1) {
			this.imageToShow = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(this.file.blob));
		}
	}

	ngAfterViewChecked(): void {
		this.cdRef.detectChanges();
	}

	fileMimeTypeIsSupportedForThumbnailfile(mime_type: FileMimeTypeModel): boolean {
		if (mime_type) {
			return this.mimeTypeSupportedForThumbnailList.some(file_mime_type => file_mime_type === mime_type);
		} else {
			return false;
		}
	}

	getFileEstension(mime_type: FileMimeTypeModel): string {
		const type: string = FileExtensionFromMimeTypeMap.get(mime_type);
		return type ? type.replace('.', '') : '';
	}
}
